export default class CidadesFiltros {
  constructor({ estadoId = null } = {}) {
    this.estadoId = estadoId;
  }
}
